import utils from 'utils';

export const UiMessage = (props: {
    type: 'loading' | 'info' | 'interaction'
    text: string,
}) => {
    return <div className={cmpClass}>
        <div className={classMap.wrapper}>
            <>
                {props.type === 'loading' && <i className={'iconfa-refresh ' + classMap.animated}></i>}
                {props.type === 'info' && <i className={'iconfa-info'}></i>}
                {props.type === 'interaction' && <i className={'iconfa-handPointUp'}></i>}
            </>
            {props.text}
        </div>
    </div>;
};

const cmpClass = 'ui-message';
const classMap = utils.generateClassMap(cmpClass, {
    animated: 'animated',
    wrapper: 'wrapper',
});
